<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Member List</h2>

            <div class="grid grid-cols-12 gap-4 mb-6 p-4 items-end">
                <div class="col-span-4">
                    <label for="from_date" class="form-label">From Date</label>
                    <input type="date" v-model="fromDate" class="form-input" id="from_date">
                </div>
                <div class="col-span-4">
                    <label for="to_date" class="form-label">To Date</label>
                    <input type="date" v-model="toDate" class="form-input" id="to_date">
                </div>
                <div class="col-span-4 flex">
                    <!-- Empty label for spacing alignment -->
                    <!-- <label class="form-label invisible">Filter</label> -->
                    <button @click="filterByDate" class="btn b-solid btn-primary-solid ">Filter</button>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div
                    class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle">
                </div>
                <div
                    class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                </div>
                <div
                    class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg">
                </div>
                <div
                    class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon">
                </div>
                <div
                    class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border">
                </div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="col-span-4 flex">
                        <div class="col-span-4 flex items-end">
                            <a class="btn b-solid btn-primary-solid resetbtn" data-modal-target="editModal"
                                @click="addModal()">Send SMS</a>
                        </div>
                        <div class="col-span-4 flex items-end">
                            <a class="btn b-solid btn-primary-solid resetbtn" @click="confirmSendExpirySms()">Send
                                Expiry SMS</a>
                        </div>
                    </div>
                    <div class="p-6 space-y-4">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Member Id</th>
                                    <!-- <th class="bg-[#B2E8D9]">Frist Name</th>
                                    <th class="bg-[#B2E8D9]">Last Name</th> -->
                                    <th class="bg-[#B2E8D9]">Full Name</th>
                                    <!-- <th class="bg-[#B2E8D9]">Package Name</th> -->
                                    <th class="bg-[#B2E8D9]">Contact</th>
                                    <!-- <th class="bg-[#B2E8D9]">Address</th> -->
                                    <th class="bg-[#B2E8D9]">Gender</th>

                                    <th class="bg-[#B2E8D9]">Start Date</th>
                                    <th class="bg-[#B2E8D9]">Expiry Date</th>
                                    <th class="bg-[#B2E8D9]">Balance</th>
                                    <th class="px-3.5 py-4">Action</th>

                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item, index)  in filteredList" :key="item.id">
                                    <td>{{ item.memberid }}</td>
                                    <!-- <td>{{item.firstname}}</td>
                                    <td>{{item.lastname}}</td> -->
                                    <td @click="viewMemberDetails(item.id)">{{ item.firstname }} {{ item.lastname }}</td>
                                    <td>{{ item.phonenumber }}</td>
                                    <!-- <td>{{item.package_name}}</td> -->
                                    <!-- <td>{{item.address}}</td> -->
                                    <td>{{ item.gender }}</td>
                                    <td>{{ item.schedule }}</td>
                                    <td>{{ getOnlyDate(item.enddate + "") }}</td>
                                    <td>{{ item.balance }}</td>


                                    <td class="px-3.5 py-4">

                                        <div class="flex items-center gap-1">
                                            <button class="btn-primary" @click="editMember(item.id)"
                                                v-show="userRole === '1'">
                                                <i class="ri-edit-2-line text-inherit text-[13px]"></i>Edit
                                            </button>
                                            <button class="btn-primary" @click="viewMemberDetails(item.id)">
                                                View
                                            </button>

                                            <router-link
                                                :to="{ name: 'updatesubscription', params: { id: item.id }, query: { memberid: item.memberid } }"
                                                class="btn-icon btn-danger-icon-light size-7">
                                                <i class="ri-add-line text-danger text-[13px]"></i>
                                            </router-link>



                                            <button class="btn-icon btn-danger-icon-light size-7"
                                                @click="deleteModal(item.id)" v-show="userRole === '1'">
                                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                            </button>
                                            
                                            <!--<button class="btn-icon btn-danger-icon-light size-7"-->
                                            <!--    @click="sendoToEssl(item.id)" v-show="userRole === '1'">-->
                                            <!--    <i class="ri-help-line text-danger text-[13px]"></i>-->
                                            <!--</button>-->
                                            <!-- <button class="btn-icon btn-primary-icon-light size-7" @click="invoicePrint(item.id)" >
                                                <i class="ri-printer-line text-primary text-[13px]"></i>
                                            </button> -->
                                        </div>
                                    </td>



                                    <!--<td>{{item.prate}}</td>
                                    <td>{{item.salerate}}</td>
                                    <td>{{item.set_rate}}</td>
                                    <td>{{item.set_qty}}</td> 
                                    <td>{{item.stock}}</td> 
                                    <td>{{parseFloat(item.prate)*parseFloat(item.stock)}}</td>  -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->

        </div>
    </div>
    <!-- End Main Content -->
    <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1"
        class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
        style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal"
                    class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal"
                                class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category"
                                class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
    <!-- Start Edit Modal -->
    <div id="editModal" tabindex="-1"
        class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full"
        style="    background: #00000052;">
        <div class="p-4 w-full max-w-lg max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal"
                    class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5">

                    <div class="mt-7">
                        <label for="tagname" class="form-label">Variable 1</label>
                        <input type="text" v-model="sms.variable1" class="form-input" id="first_input"
                            placeholder="Variable1" autocomplete="off" required>
                    </div>
                    <div class="mt-7">
                        <label for="tagname" class="form-label">Variable 2</label>
                        <input type="text" v-model="sms.variable2" class="form-input" id="first_input"
                            placeholder="Variable2" autocomplete="off" required>
                    </div>

                    <div class="flex justify-end mt-7">
                        <button @click="send_sms"
                            class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Send</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Edit Modal -->




</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
    name: 'AddProduct',
    components: {

    },
    mounted() {
        this.getBasics();
        this.filteredList = [...this.memberlist];
        //  console.log(this.filteredList);
    },
    data() {
        const today = new Date().toISOString().split('T')[0];
        return {
            isAdd: 0,
            isEdit: 0,
            fromDate: today,
            toDate: today,
            isDelete: 0,
            deleteId: 0,
            productsList: [],
            filteredList: [],
            memberlist: [],
            userRole: localStorage.getItem('userRole'),
            datatable: null,
            //  product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
            //  employees: {empname:'',emprole:'0',isMainAdmin:0},
            customer: {

                memberid: '',
                firstname: '',
                lastname: '',
                phonenumber: '',
                address: '',
                gender: '',
                startdate: '',
                enddate: '',
                email: '',


            },
            sms: {
                variable1: '',
                variable12: ''
            },
            responseMessage: ''
        }
    },
    methods: {
        editMember(id) {
            this.$router.push({ name: 'customer', query: { id: id } });
        },
        getOnlyDate(date) {

            try {
                if (date) {
                    var dateHere = date;
                    return dateHere.split(' ')[0];
                } else
                    return '';

            } catch (error) {
                alert(error);
                return '';
            }

        },
        viewMemberDetails(memberId) {
            this.$router.push({ name: 'member-details', query: { id: memberId } });
        },
        closeModal() {

            $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
            this.isAdd = 0;
            this.isEdit = 0;
            this.isDelete = 0;
            this.deleteId = 0;
        },
        addModal() {
            this.cat = { name: '', status: 'Active' };
            if (!this.isAdd)
                $("#editModal").removeClass('hidden');
            else
                $("#editModal").addClass('hidden');
            this.isAdd = !this.isAdd;
        },

        editModal(item) {
            if (item) {
                let copy = JSON.parse(JSON.stringify(item));
                this.cat = copy;
            }
            if (!this.isEdit)
                $("#editModal").removeClass('hidden');
            else
                $("#editModal").addClass('hidden');
            this.isEdit = !this.isEdit;
        },

        deleteModal(id) {
            this.deleteId = id;
            if (!this.isDelete)
                $("#deleteModal").removeClass('hidden');
            else
                $("#deleteModal").addClass('hidden');
            this.isDelete = !this.isDelete;
        },
        async getBasics() {
            var self = this;
            axios.post('getmemberlist').then(function (response) {
                self.memberlist = response.data.customer;
                self.employees = response.data.userDetails;
                self.filteredList = self.memberlist;

            }).then(() => {
                self.datatable = $(".datatable").DataTable({
                    "paging": true,
                    "ordering": true,
                    "autoWidth": false,
                    dom: 'Bfrtip',
                    buttons: [
                        {
                            extend: 'excelHtml5',
                            title: 'Excel',
                        },
                    ],
                });

            });;
        },
        send_sms() {
            var self = this;
            axios.post('sendsms2', {
                variable1: self.sms.variable1,
                variable2: self.sms.variable2
            }).then(function (response) {
                if (response.data.status == 'yes') {
                    self.responseMessage = 'SMS sent successfully!';
                    self.closeModal();
                } else {
                    self.responseMessage = 'Failed to send SMS.';
                }
            }).catch(function (error) {
                console.error(error);
                self.responseMessage = 'An error occurred while sending the SMS.';
            });
        },
        filterByDate() {
            if ($.fn.dataTable.isDataTable('.datatable')) {
                $('.datatable').DataTable().destroy(); // Destroy existing instance
            }
            if (this.fromDate && this.toDate) {
                const from = new Date(`${this.fromDate}T00:00:00`);
                const to = new Date(`${this.toDate}T23:59:59`);

                this.filteredList = this.memberlist.filter(item => {
                    const itemDate = new Date(item.iddate);
                    return itemDate >= from && itemDate <= to;
                });
                this.$nextTick(() => {

                    self.datatable = $(".datatable").DataTable({
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false
                    });

                });

            } else {
                this.filteredList = [...this.memberlist];
            }
        },
        confirmSendExpirySms() {
            this.$swal({
                title: "Are you sure?",
                text: "Do you want to send the expiry SMS with the specified date range?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes"
            }).then((result) => {
                if (result.isConfirmed) {
                    const fromDate = this.fromDate; // Assume fromDate and toDate are defined in your component data
                    const toDate = this.toDate;

                    const payload = {
                        fromDate: fromDate,
                        toDate: toDate
                    };

                    // Send the payload to the CodeIgniter 4 backend
                    axios.post('sendExpirySms', payload)
                        .then(response => {
                            const responseData = response.data;
                            let successMessage = responseData.message || "Expiry SMS has been sent successfully.";

                            this.$swal(
                                'Success!',
                                successMessage,
                                'success'
                            );
                        })
                        .catch(error => {
                            const errorMessage = error.response && error.response.data && error.response.data.message
                                ? error.response.data.message
                                : 'There was an issue sending the expiry SMS.';

                            this.$swal(
                                'Error!',
                                errorMessage,
                                'error'
                            );
                        });
                } else {
                    this.$swal(
                        'Cancelled',
                        'Expiry SMS was not sent.',
                        'info'
                    );
                }
            });
        },
        // async getBasics() {
        //             var self = this;
        //             axios.post('getLeadList').then(function (response) {
        //                  self.catList = response.data.cats;
        //                  self.employees = response.data.userDetails;
        //             });
        //         },

        delete_category() {
            var self = this;
            axios.post('deletemember', { deleteId: this.deleteId })
                .then(response => {
                    self.memberlist = response.data.customer;
                    self.employees = response.data.userDetails;
                    self.closeModal();
                })
                .catch(error => {
                    console.log('Error on Authentication: ' + error);
                });
        },


    sendoToEssl(_memberid) {
            var self = this;
            axios.post('addToEssl', { memberid: _memberid })
                .then(response => {
                    self.memberlist = response.data.customer;
                    self.employees = response.data.userDetails;
                    self.closeModal();
                })
                .catch(error => {
                    console.log('Error on Authentication: ' + error);
                });
        },
        
    },
    // watch: {
    //         fromDate: 'filterByDate',
    //         toDate: 'filterByDate'
    //     }
}
</script>
<style scoped>
.invoice-container {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: Arial, sans-serif;
}

.header {
    text-align: center;
}

.company-details p {
    margin: 0;
}

.bill-details {
    margin-top: 20px;
}

.bill-to,
.invoice-info {
    display: inline-block;
    vertical-align: top;
    width: 48%;
}

.table {
    width: 100%;
    margin-top: 20px;
    border-collapse: collapse;
}

.table th,
.table td {
    border: 1px solid #000;
    padding: 8px;
    text-align: left;
}

.totals {
    margin-top: 20px;
    text-align: right;
}

.footer {
    margin-top: 40px;
    text-align: center;
    font-size: 12px;
}
</style>